import styled from "@emotion/styled";

export const TableWrapper = styled.div`
  & > div > div {
    padding: 0;
  }
`;
